<template>
  <div class="add-contract-page">
    <div class="page-header">
      <a-page-header :ghost="true" title="新建合同">
        <template slot="tags">
          <div class="step-wrap">
            <a-steps :current="current">
              <a-step title="选择签约租户" description=""> </a-step>
              <a-step title="设置合同期限/账单规则" description=""> </a-step>
              <a-step title="选择计费设备" description=""> </a-step>
            </a-steps>
          </div>
        </template>
        <template slot="extra">
          <a-button button @click="onGoBack" type="primary"> 返 回 </a-button>
        </template>
      </a-page-header>
    </div>
    <!-- <div class="step">
      <div class="title">
        <div class="line"></div>
        <div>预付费签约</div>
      </div>
      <div class="step-wrap">
        <a-steps :current="current">
          <a-step title="选择签约租户" description=""> </a-step>
          <a-step title="设置合同期限/账单规则" description=""> </a-step>
          <a-step title="选择计费设备" description=""> </a-step>
        </a-steps>
      </div>
    </div> -->
    <div class="step-content">
      <div class="tenant">
        <div class="title">
          <div class="line"></div>
          <div>选择签约租户</div>
        </div>
        <div class="select" v-if="current === 0">
          <a-form :form="tenantForm">
            <!-- <a-form-item nostyle> -->
            <a-form-item label="选择租户">
              <a-select
                placeholder="请选择租户"
                v-decorator="[
                  'tenatId',
                  { rules: [{ required: true, message: '请选择租户' }] },
                ]"
                :showSearch="true"
                @search="getTenantData"
                @change="changeTenant"
              >
                <a-select-option
                  v-for="item in tenantList"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.tenatName }}</a-select-option
                >
              </a-select>
            </a-form-item>
            <!-- </a-form-item> -->
            <a-form-item class="name-item">
              <div class="name">
                <div>没有找到租户？</div>
                <a @click="createTenantVisible = true">新建租户</a>
              </div>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" @click="saveTenant">下一步</a-button>
            </a-form-item>
          </a-form>
        </div>
        <div class="tenant-detail" v-else>
          <a-row :gutter="[24, 24]">
            <a-col :span="12">
              <div class="name">
                <i class="iconfont icon-icon-user"></i>
                <div>租户名称：{{ tenantObj.tenatName || "--" }}</div>
              </div>
            </a-col>
            <a-col :span="12">
              <div class="name">
                <i class="iconfont icon-jiaoseleixing"></i>
                <div>
                  租户类型：{{ tenantType[tenantObj.tenantType] || "--" }}
                </div>
              </div>
            </a-col>
            <a-col :span="12">
              <div class="name">
                <i class="iconfont icon-shouji"></i>
                <div>联系方式：{{ tenantObj.contactPhone || "--" }}</div>
              </div>
            </a-col>
            <a-col :span="12">
              <div class="name">
                <i class="iconfont icon-youxiang"></i>
                <div>租户邮箱：{{ tenantObj.tenantEmail || "--" }}</div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="contract" v-if="current !== 0">
        <div class="title">
          <div class="line"></div>
          <div>设置合同期限/账单规则</div>
        </div>
        <a-form v-if="current === 1" :form="contractForm">
          <a-form-item label="合同期限" style="margin-bottom: 20px">
            <a-range-picker
              v-decorator="[
                'time',
                { rules: [{ required: true, message: '请选择合同期限' }] },
              ]"
            >
              <a-icon slot="suffixIcon" type="calendar" />
            </a-range-picker>
          </a-form-item>
          <a-form-item label="备注">
            <a-textarea placeholder="请输入备注" v-decorator="['remark']" />
          </a-form-item>
          <a-form-item class="btns" :wrapperCol="{ offset: 7 }">
            <a-button @click="preStep">上一步</a-button>
            <a-button
              type="primary"
              style="margin-left: 20px"
              @click="saveContract"
              >下一步</a-button
            >
          </a-form-item>
        </a-form>
        <div class="detail" v-if="current === 2">
          <div class="detail-wrap">
            <a-row style="margin: 12px">
              <div
                class="name"
                style="color: #909ca6; display: flex; align-items: center"
              >
                <i class="iconfont icon-riqi"></i>
                <div>
                  合同日期：{{ contractObj.effectiveDate || "--" }}~{{
                    contractObj.expireDate || "--"
                  }}
                </div>
              </div>
            </a-row>
            <a-row style="margin: 12px">
              <div
                class="name"
                style="color: #909ca6; display: flex; align-items: center"
              >
                <i class="iconfont icon-beizhu"></i>
                <div>备注：{{ contractObj.remark || "--" }}</div>
              </div>
            </a-row>
          </div>
        </div>
      </div>
      <div class="device" id="table" v-show="current === 2">
        <div class="titl-add">
          <div class="titl">
            <div class="line"></div>
            <div>设备列表</div>
          </div>
          <a-button type="primary" class="add" @click="openDeviceModal"
            >添加设备</a-button
          >
        </div>
        <a-form :form="deviceForm">
          <a-form-item nostyle>
            <a-table
              bordered
              rowKey="deviceId"
              :columns="deviceColumns"
              :dataSource="dataSource"
              :pagination="addPagination"
              @change="(pagination) => getDeviceData(pagination.current - 1)"
            >
              <template slot="value" slot-scope="text, record">
                <div class="name" v-if="Object.keys(record).includes('id')">
                  {{ text || "0" }}
                </div>
              </template>
              <template slot="price" slot-scope="text, record">
                <a-form-item selfUpdate class="table-form-item">
                  <a-input-number
                    :min="0"
                    v-decorator="[`${record.deviceId}-unitPrice`]"
                  />
                </a-form-item>
              </template>
              <template slot="radio" slot-scope="text, record">
                <a-form-item selfUpdate class="table-form-item">
                  <a-input-number
                    :min="0"
                    v-decorator="[
                      `${record.deviceId}-baseNumber`,
                      { initialValue: 1 },
                    ]"
                  />
                </a-form-item>
              </template>
              <template slot="operation" slot-scope="record">
                <div class="handle" style="display: flex; align-items: center">
                  <a-tooltip title="移除">
                    <div
                      class="icon"
                      style="
                        width: 40px;
                        height: 40px;
                        background: #091121;
                        border-radius: 15px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-right: 24px;
                      "
                      @click="showDeleteModal(record)"
                    >
                      <i class="iconfont icon-yichu" />
                    </div>
                  </a-tooltip>
                </div>
              </template>
            </a-table>
          </a-form-item>
        </a-form>
        <div class="btns">
          <a-button type="primary" @click="preStep">上一步</a-button>
          <a-button
            type="primary"
            style="margin-left: 20px"
            @click="onSaveContract"
            >保存</a-button
          >
        </div>
      </div>
    </div>
    <a-modal
      class="device-select-modal"
      title="设备列表"
      width="800px"
      :visible="deviceVisible"
      :maskClosable="false"
      @ok="saveDevice"
      @cancel="handleClose"
    >
      <div class="device-content">
        <div class="title">设备区域选择：</div>
        <a-cascader
          :options="options"
          :load-data="loadData"
          placeholder="请选择"
          changeOnSelect
          v-model="cascaderVal"
          @change="changeCascder"
        />
        <div class="device-list">
          <a-checkbox-group @change="changeCheck" :value="checkVal">
            <div
              class="device-item"
              v-for="(item, index) in deviceList"
              :key="index"
            >
              <div class="device-wrap" v-if="item.list.length > 0">
                <div class="title">{{ item.title }}</div>
                <a-row :gutter="[16, 16]">
                  <a-col
                    :span="6"
                    v-for="(child, indexs) in item.list"
                    :key="indexs"
                  >
                    <a-checkbox
                      :value="child.id"
                      :disabled="selectDeviceIds.includes(child.id)"
                      >{{ child.deviceName }}</a-checkbox
                    >
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-checkbox-group>
        </div>
      </div>
    </a-modal>
    <a-modal
      class="create-tenant-modal"
      title="添加租户 "
      :visible="createTenantVisible"
      :maskClosable="false"
      @ok="handleSave"
      @cancel="handleCloseTenant"
    >
      <a-form :form="form" :labelCol="{ span: 8 }" :wrapperCol="{ span: 12 }">
        <a-form-item label="租户名称">
          <a-input
            placeholder="请输入租户名称"
            v-decorator="[
              'tenatName',
              { rules: [{ required: true, message: '请输入租户名称' }] },
            ]"
          />
        </a-form-item>
        <a-form-item label="联系方式">
          <a-input
            placeholder="请输入联系方式"
            v-decorator="[
              'contactPhone',
              {
                rules: [
                  { required: true, message: '请输入联系方式' },
                  {
                    validator: (rule, val, cb) => {
                      const testReg = /^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/;
                      if (val) {
                        if (testReg.test(val)) {
                          cb();
                        } else cb('请输入正确联系方式');
                      } else cb();
                    },
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="租户邮箱">
          <a-input
            placeholder="请输入邮箱"
            v-decorator="[
              'tenantEmail',
              {
                rules: [
                  { required: true, message: '请输入邮箱' },
                  {
                    validator: (rule, val, cb) => {
                      const testReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
                      if (val) {
                        if (testReg.test(val)) {
                          cb();
                        } else cb('请输入正确的邮箱');
                      } else cb();
                    },
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="租户类型">
          <a-select
            placeholder="请选择租户类型"
            v-decorator="[
              'tenantType',
              { rules: [{ required: true, message: '请选择租户类型' }] },
            ]"
          >
            <a-select-option value="INDIVIDUAL">个体</a-select-option>
            <a-select-option value="ENTERPRISE">企业</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="企业信用代码"
          selfUpdate
          v-if="form.getFieldValue('tenantType') === 'ENTERPRISE'"
        >
          <a-input
            placeholder="请输入企业信用代码"
            v-decorator="['enterpriseCode']"
          />
        </a-form-item>
        <a-form-item
          label="身份证号码"
          selfUpdate
          v-if="form.getFieldValue('tenantType') === 'INDIVIDUAL'"
        >
          <a-input placeholder="请输入身份证号码" v-decorator="['idCard']" />
        </a-form-item>
        <a-form-item label="租赁地址">
          <a-input placeholder="请输入租赁地址" v-decorator="['address']" />
        </a-form-item>
        <a-form-item label="备注">
          <a-textarea placeholder="请输入备注" v-decorator="['remark']" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import {
  tenantPage,
  //contractDeviceList,
  roomDeviceList,
  roomList,
  floorList,
  estateList,
  contractAdd,
  tenantAdd,
} from "./service";
import moment from "moment";
import eventStatusMixin from "../../../mixins/eventStatus";
import scrollbarInit from "../../../utils/perfectScrollBar";
const types = {
  ELECTRIC: "电表",
  WATER: "水表",
  COLD_WATER: "冷水表",
  HOT_WATER: "热水表",
  GAS: "燃气表",
  OTHER: "其他",
};

export default {
  mixins: [eventStatusMixin],
  data() {
    return {
      tenantType: {
        INDIVIDUAL: "个体",
        ENTERPRISE: "企业",
      },
      form: this.$form.createForm(this),
      tenantForm: this.$form.createForm(this),
      contractForm: this.$form.createForm(this),
      deviceForm: this.$form.createForm(this),
      current: 0,
      tenantList: [],

      dataSource: [],
      addPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      addDeviceList: [],
      selectDeviceIds: [],

      deviceVisible: false,
      options: [],
      deviceList: [],
      cascaderVal: [],
      checkVal: [],

      tenantObj: {},
      contractObj: {},

      createTenantVisible: false,
    };
  },
  computed: {
    deviceColumns: function () {
      const columns = [
        {
          title: "设备类型",
          dataIndex: "productType",
          customRender: (text) => {
            return types[text] || "--";
          },
        },
        {
          title: "设备名称",
          dataIndex: "deviceName",
          customRender: (text) => {
            return text || "--";
          },
        },
        {
          title: "合同起始读数",
          dataIndex: "initialGraduaction",
          customRender: (text) => {
            return text || "0";
          },
          scopedSlots: {
            customRender: "value",
          },
        },
        {
          title: "设备单价",
          dataIndex: "unitPrice",
          scopedSlots: {
            customRender: "price",
          },
        },
        {
          title: "倍率",
          dataIndex: "baseNumber",
          scopedSlots: {
            customRender: "radio",
          },
        },
        {
          title: "操作",
          dataIndex: "",
          scopedSlots: {
            customRender: "operation",
          },
        },
      ];
      return columns;
    },
  },
  created() {
    this.getTenantData();
    // this.getDeviceData();
    //   this.getSelectDeviceData();
    this.getBuildData();
  },
  mounted() {
    this.createScroll();
  },
  methods: {
    createScroll() {
      const scrollBar = scrollbarInit("#table");
      const dom = document.querySelector("#table");
      dom.scrollTop = 0;
      scrollBar.update();
    },
    disabledDate(current) {
      return (
        current && current < moment(this.tenantObj.expireDate).endOf("day")
      );
    },
    async getTenantData(val) {
      try {
        const params = {
          isPage: 0,
          tenatName: val,
        };
        const res = await tenantPage.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          this.tenantList = res.data.items;
        }
      } catch (err) {
        console.error(err);
      }
    },
    changeTenant(val) {
      //console.log("change", val);
      let tenantList = this.tenantList;
      tenantList.map((item) => {
        if (item.id === val) {
          this.tenantObj = item;
        }
      });
    },

    openDeviceModal() {
      this.deviceVisible = true;
    },
    handleClose() {
      this.deviceVisible = false;
      this.deviceList = [];
      this.cascaderVal = [];
      this.checkVal = [];
    },
    async getBuildData() {
      try {
        const params = {};
        const res = await estateList.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          const data = res.data.map((item) => {
            return {
              ...item,
              label: item.estateName,
              value: item.id,
              isLeaf: false,
              type: "build",
            };
          });
          this.options = data;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;

      if (targetOption.type === "build") {
        targetOption.loading = false;
        const res = await this.getFloorData(targetOption.id);
        if (res.bizCode === 1) {
          const data = res.data.map((item) => {
            return {
              ...item,
              label: item.floorName,
              value: item.id,
              type: "floor",
              isLeaf: false,
            };
          });
          targetOption.children = data;
          this.options = [...this.options];
        }
      } else if (targetOption.type === "floor") {
        const res = await this.getAreaData(
          targetOption.estateId,
          targetOption.id
        );
        if (res.bizCode === 1) {
          targetOption.loading = false;
          const data = res.data.items.map((item) => {
            return {
              ...item,
              label: item.roomName,
              value: item.id,
              type: "area",
            };
          });
          targetOption.children = data;
          this.options = [...this.options];
        }
      }
    },
    changeCascder(val) {
      //console.log(val, options);
      this.cascaderVal = val;
      this.checkVal = [];
      this.deviceList = [];
      if (val.length === 3) {
        const params = {
          estateId: val[0],
          floorId: val[1],
          roomId: val[2],
        };
        this.getAreaDeviceData(params);
      }
    },
    async getFloorData(id) {
      try {
        const params = {
          estateId: id,
        };

        const res = await floorList.request(params, {
          showBizRemind: true,
        });

        return res;
      } catch (err) {
        console.error(err);
      }
    },
    async getAreaData(estateId, floorId) {
      try {
        const params = {
          estateId,
          floorId,
          isPage: 0,
        };

        const res = await roomList.request(params, {
          showBizRemind: true,
        });

        return res;
      } catch (err) {
        console.error(err);
      }
    },
    async getAreaDeviceData(params) {
      try {
        let checkVal = [];
        this.addDeviceList.map((item) => {
          checkVal.push(item.deviceId);
        });
        const res = await roomDeviceList.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          const types = {
            ELECTRIC: "电表",
            WATER: "水表",
            COLD_WATER: "冷水表",
            HOT_WATER: "热水表",
            GAS: "燃气表",
            OTHER: "其他",
          };
          const data = res.data.map((item) => {
            return {
              ...item,
              title: types[item.productType] || "其他",
            };
          });
          this.checkVal = checkVal;
          this.deviceList = data;
        }
      } catch (err) {
        console.error(err);
      }
    },
    changeCheck(val) {
      console.log(val);
      this.checkVal = val;
    },
    //保存设备
    async saveDevice() {
      let checkVal = this.checkVal;
      let deviceList = this.deviceList;
      let arr = [];
      deviceList.map((item) => {
        if (Array.isArray(item.list)) {
          item.list.map((child) => {
            if (checkVal.includes(child.id)) {
              arr.push({
                deviceName: child.deviceName,
                deviceId: child.id,
                productType: item.productType,
                typeName: item.title,
              });
            }
          });
        }
      });
      let tmpDataSource = arr.concat(this.dataSource);
      this.addDeviceList = arr;
      if (tmpDataSource.length > 10) {
        this.addPagination = {
          current: this.addPagination.current,
          pageSize: tmpDataSource.length,
          total: this.addPagination.total + arr.length,
        };
      }
      this.dataSource = tmpDataSource;
      this.createScroll();
      this.handleClose();
    },
    //设备移除
    async removeDevice(record) {
      if (this.hasEventState("removeDevice")) return;
      try {
        this.addEventState("removeDevice");
        let tmpDataSource = this.dataSource.filter(
          (item) => item.deviceId !== record.deviceId
        );
        let arr = this.addDeviceList.filter(
          (item) => item.deviceId !== record.deviceId
        );

        this.addPagination = {
          current: this.addPagination.current,
          pageSize: tmpDataSource.length > 10 ? tmpDataSource.length : 10,
          total: this.addPagination.total - 1,
        };
        this.dataSource = tmpDataSource;
        this.addDeviceList = arr;
        //this.setFormDaat();
        //}
      } catch (err) {
        console.error(err);
      } finally {
        this.removeEventState("removeDevice");
      }
    },
    showDeleteModal(record) {
      if (record.contractTotal > 0) {
        return;
      }
      let that = this;
      this.$confirm({
        class: "delete-confirm-modal",
        title: "确定移除设备吗？",
        content: "确认移除后不可恢复！",
        okText: "确定",
        okType: "primary",
        centered: true,
        width: 320,
        icon: () => (
          <a-icon type="info-circle" theme="twoTone" two-tone-color="#0F9F64" />
        ),
        onOk() {
          that.removeDevice(record);
        },
        onCancel() {
          console.log("cancel");
        },
      });
    },
    setFormDaat() {
      this.$nextTick(() => {
        const arr = this.dataSource;
        let formVals = {};
        arr.map((item) => {
          if (!Object.keys(item).includes("id")) {
            formVals[`${item.deviceId}-initialGraduaction`] =
              item.initialGraduaction || "0";
          }
        });
        this.deviceForm.setFieldsValue({
          ...formVals,
        });
      });
    },
    preStep() {
      if (this.current === 1) {
        this.contractForm.resetFields();
        this.current = 0;
        this.contractObj = {};
      } else {
        this.current = 1;
      }
    },
    async saveTenant() {
      const formVal = await this.tenantForm.validateFields();
      this.tenantList.map((item) => {
        if (item.id === formVal.tenatId) {
          this.tenantObj = item;
          this.current = 1;
        }
      });
    },
    async saveContract() {
      const formVals = await this.contractForm.validateFields();
      this.contractObj = {
        ...formVals,
        effectiveDate: moment(formVals.time[0]).format("YYYY-MM-DD 00:00:00"),
        expireDate: moment(formVals.time[1]).format("YYYY-MM-DD 23:59:59"),
      };
      this.current = 2;
      this.createScroll();
    },
    //合同新增、修改
    async onSaveContract() {
      if (this.hasEventState("onSaveContract")) return;
      try {
        this.addEventState("onSaveContract");
        let contractObj = this.contractObj;
        const deviceVals = await this.deviceForm.validateFields();
        const contractDeviceDtoList = this.deviceForms(
          deviceVals,
          this.dataSource,
          this.deviceColumns
        );
        let start = moment(contractObj.time[0]);
        let end = moment(contractObj.time[1]);
        let contractTeam = end.diff(start, "months", true);
        //console.log(formVals,deviceVals,contractDeviceDtoList);
        const tenantParams = {
          tenatId: this.tenantObj.id,
          remark: contractObj.remark,
          //settlementCycle: formVals.settlementCycle,
          effectiveDate: contractObj.effectiveDate,
          expireDate: contractObj.expireDate,
          contractTeam: contractTeam.toFixed(2),
          tenatName: this.tenantObj.tenatName,
          contactPhone: this.tenantObj.contactPhone,
          contractDeviceDtoList,
        };

        console.log(tenantParams);

        const res = await contractAdd.request(tenantParams, {
          showBizRemind: true,
          lock: true,
        });

        if (res.bizCode === 1) {
          this.$message.success("保存成功");
          this.onGoBack();
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.removeEventState("onSaveContract");
      }
    },

    deviceForms(values, dataSource, columns) {
      const arr = [];
      dataSource.map((item) => {
        let tmp = {
          deviceId: item.deviceId,
        };
        if (Object.keys(item).includes("id")) {
          tmp["id"] = item.id;
        }
        for (let i = 0; i < columns.length; i++) {
          let names = `${item.deviceId}-${columns[i]["dataIndex"]}`;
          if (Object.keys(values).includes(`${names}`)) {
            tmp[columns[i]["dataIndex"]] = values[names];
          }
        }
        arr.push({ ...tmp });
      });
      return arr;
    },
    onGoBack() {
      this.$router.push({
        path: "/app/signing/contractmanage",
      });
    },
    handleCloseTenant() {
      this.createTenantVisible = false;
      this.form.resetFields();
    },
    async handleSave() {
      if (this.hasEventState("handleSave")) return;
      try {
        this.addEventState("handleSave");
        const formVals = await this.form.validateFields();
        const params = {
          ...formVals,
        };

        const res = await tenantAdd.request(params, {
          showBizRemind: true,
          lock: true,
        });
        if (res.bizCode === 1) {
          this.$message.success("添加成功");
          this.handleCloseTenant();
          this.getTenantData();
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.removeEventState("handleSave");
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../utils/convertPxToDesighViewport/convertPxToDesighViewport";
//.convertPxToDesighVH(20)[] .convertPxToDesighVW(20)[]
.add-contract-page {
  width: 100%;
  overflow: hidden;
  .page-header {
    background: #192430;
    border: .convertPxToDesighVH(2) [] solid #293646;
    border-radius: .convertPxToDesighVH(10) [];
    margin-bottom: .convertPxToDesighVH(24) [];
    height: .convertPxToDesighVH(80) [];
    > .ant-page-header {
      background: transparent;
      height: .convertPxToDesighVH(80) [];
      padding: 0 .convertPxToDesighVW(24) [] !important;
      border-radius: .convertPxToDesighVH(10) [];
    }
    .step-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  > .step-content {
    margin-top: .convertPxToDesighVH(20) [];
    > .tenant {
      background: #192430;
      border: .convertPxToDesighVH(2) [] solid #293646;
      border-radius: .convertPxToDesighVH(10) [];
      width: 100%;
      padding: .convertPxToDesighVH(20) [];
      height: .convertPxToDesighVH(220) [];
      > .title {
        display: flex;
        align-items: center;
        .line {
          width: .convertPxToDesighVW(4) [];
          height: .convertPxToDesighVH(16) [];
          background: #0f9f64;
          border-radius: .convertPxToDesighVH(4) [];
          margin-right: .convertPxToDesighVW(8) [];
        }
        > div {
          font-size: .convertPxToDesighVH(16) [];
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: .convertPxToDesighVH(21) [];
          color: #e2f2ff;
        }
      }
      .select {
        width: .convertPxToDesighVW(1000) [];
        height: .convertPxToDesighVH(150) [];
        margin: 0 auto;
        .ant-form {
          width: .convertPxToDesighVW(700) [];
          margin: 0 auto;
          .name-item {
            .ant-col {
              .ant-form-item-control {
                .ant-form-item-children {
                  .name {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }
                }
              }
            }
          }
          .ant-row {
            display: flex;
            align-items: center;
            justify-content: center;
            .ant-form-item-label {
              width: .convertPxToDesighVW(60) [] !important;
            }
          }
        }
      }
      .tenant-detail {
        height: .convertPxToDesighVH(120) [];
        width: .convertPxToDesighVW(1000) [];
        background: #091121;
        margin: 0 auto;
        border-radius: .convertPxToDesighVH(20) [];
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: .convertPxToDesighVH(16) [];
        .ant-row {
          width: .convertPxToDesighVW(700) [];
          .ant-col {
            .name {
              font-size: .convertPxToDesighVH(14) [];
              font-family: Source Han Sans CN;
              font-weight: 500;
              line-height: .convertPxToDesighVH(24) [];
              color: #909ca6;
              display: flex;
              align-items: center;
              div {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
    > .contract {
      margin-top: .convertPxToDesighVH(20) [];
      width: 100%;
      height: .convertPxToDesighVH(240) [];
      padding: .convertPxToDesighVH(20) [];
      background: #192430;
      border: .convertPxToDesighVH(2) [] solid #293646;
      border-radius: 10px;
      > .title {
        display: flex;
        align-items: center;
        // margin-bottom: 39px;
        .line {
          width: .convertPxToDesighVW(4) [];
          height: .convertPxToDesighVH(16) [];
          background: #0f9f64;
          border-radius: .convertPxToDesighVH(4) [];
          margin-right: .convertPxToDesighVW(8) [];
        }
        > div {
          font-size: .convertPxToDesighVH(16) [];
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: .convertPxToDesighVH(21) [];
          color: #e2f2ff;
        }
      }
      .ant-form {
        margin: 0 auto;
        width: .convertPxToDesighVW(700) [];
        .ant-form-item {
          .ant-form-item-control-wrapper {
            .ant-form-item-control {
              .ant-form-item-children {
                .ant-calendar-picker {
                  .ant-calendar-picker-input {
                    width: .convertPxToDesighVW(390) [] !important;
                  }
                }
              }
            }
          }
        }
      }
      .detail {
        width: .convertPxToDesighVW(1000) [];
        height: .convertPxToDesighVH(140) [];
        background: #091121;
        margin: .convertPxToDesighVH(16) [] auto;
        border-radius: .convertPxToDesighVH(20) [];
        display: flex;
        justify-content: center;
        align-items: center;
        .detail-wrap {
          width: .convertPxToDesighVW(700) [];
          .ant-row {
            .name {
              div {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
    > .device {
      margin-top: .convertPxToDesighVH(20) [];
      width: 100%;
      padding: .convertPxToDesighVH(20) [];
      background: #192430;
      border: .convertPxToDesighVH(2) [] solid #293646;
      border-radius: .convertPxToDesighVH(10) [];
      height: calc(100vh - .convertPxToDesighVH(720) []);
      // overflow: auto;
      > .titl-add {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: .convertPxToDesighVH(20) [];
        > .titl {
          display: flex;
          align-items: center;
          .line {
            width: .convertPxToDesighVW(4) [];
            height: .convertPxToDesighVH(16) [];
            background: #0f9f64;
            border-radius: .convertPxToDesighVH(4) [];
            margin-right: .convertPxToDesighVW(8) [];
          }
          > div {
            font-size: .convertPxToDesighVH(16) [];
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: .convertPxToDesighVH(21) [];
            color: #e2f2ff;
            margin-bottom: .convertPxToDesighVH(10) [];
          }
        }
      }
      > .btns {
        margin-top: .convertPxToDesighVH(20) [];
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
.table-form-item {
  margin-bottom: 0px;
}
::v-deep.device-select-modal {
  > .ant-modal-wrap {
    > .ant-modal {
      > .ant-modal-content {
        > .ant-modal-body {
          background: #f0f3f8;
          min-height: .convertPxToDesighVH(300) [];
          > .device-content {
            width: 100%;
            height: 100%;
            padding: 0px .convertPxToDesighVW(20) [];
            > .title {
              font-size: .convertPxToDesighVH(14) [];
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: .convertPxToDesighVH(19) [];
              color: #909ca6;
              margin-bottom: .convertPxToDesighVH(24) [];
            }
            > .ant-cascader-picker {
              width: 100%;
              background: #0c1014;
              border-radius: .convertPxToDesighVH(20) [];
              border: none;
              color: #ccd3d9;
              outline: none;
              &:hover {
                border: 1px solid #22dd90;
              }
              > .ant-input {
                border: none;
                border-radius: .convertPxToDesighVH(20) [];
                outline: none;
              }
            }
            > .device-list {
              margin-top: .convertPxToDesighVH(24) [];
              width: 100%;
              > .ant-checkbox-group {
                width: 100%;
                > .device-item {
                  width: 100%;
                  background: #161a1c;
                  margin-bottom: .convertPxToDesighVH(20) [];
                  border-radius: .convertPxToDesighVH(5) [];
                  .device-wrap {
                    > .title {
                      display: flex;
                      align-items: center;
                      padding: 0px .convertPxToDesighVW(16) [];
                      height: .convertPxToDesighVH(40) [];
                      background: #161a1c;
                      border-bottom: 1px solid #2a3a40;
                      border-radius: .convertPxToDesighVH(5) []
                        .convertPxToDesighVW(5) [] 0px 0px;
                      font-size: .convertPxToDesighVH(14) [];
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      line-height: .convertPxToDesighVH(19) [];
                      color: #a5b8b4;
                    }
                    > .ant-row {
                      padding: .convertPxToDesighVH(16) [];
                    }
                  }
                }
              }
            }
          }
        }
        > .ant-modal-footer {
          background: #f0f3f8;
        }
      }
    }
  }
}

#table {
  position: relative;
  overflow: hidden;
}
</style>
